import Vue from 'vue'
import App from './App.vue'
import JsonExcel from 'vue-json-excel'
import Vuetify from 'vuetify/lib'
import VueRouter from 'vue-router'
import 'vuetify/src/stylus/app.styl'
import router from './router'

Vue.use(VueRouter);
Vue.use(Vuetify, {
  iconfont: 'md',
})

Vue.component('downloadExcel', JsonExcel)

Vue.config.productionTip = false

new Vue({
  router,
  template: '<App/>',
  components: { App },
  render: h => h(App)
}).$mount('#app')
